{
  "payments": "Payments",
  "settlement": "Settlement",
  "wire-tranfers": "Wire Transfers",
  "payee": "Payee",
  "account": "Account",
  "status": "Status",
  "amount": "Amount",
  "origination_charges": "A. Origination Charges",
  "did_not_shop_for": "B. Did Not Shop For",
  "did_shop_for": "C. Did Shop For",
  "taxes_and_fees": "E. Taxes and Fees",
  "prepaids": "F. Prepaids",
  "escrow": "G. Escrow",
  "other_charges": "H. Other Charges",
  "no-charges": "No charges created yet",
  "no-charges-leyend": "Please, go to charges section to add more Information",
  "authorization": "It's need to authorize the transfer",
  "authorize": "Authorize",
  "required": "Required",
  "reference": "Reference",
  "authorize-wire-transfer-option": "Please, select an option to authorize or reject the next transfer:",
  "reject": "Reject",
  "authorize-transfer": "Authorize Transfer",
  "create-wire-tranfer": "Create Wire Tranfer",
  "create-wire-transfer-advice": "When a transfer is created, the request will be sent to the corresponding users for authorization.",
  "create-wire-transfer": "Create Wire Transfer",
  "instructions": "Instructions",
  "kind": "Kind",
  "description": "Description",
  "party": "Party",
  "file": "File",
  "authorizations": "Authorizations",
  "disbursements-and-receipts": "Disbursements",
  "started-at": "Started At",
  "audit": "Audit",
  "transfers": "Transfers",
  "total": "Total",
  "accounts": "Accounts",
  "disbursements": "Disbursements",
  "no-options": "No Options"
}
